export const UPDATE_ROLE_ID = "UPDATE_ROLE_ID";


// WEBPACK FOOTER //
// ./modules/role-id-window-post/actions/actionTypes.ts